<template>
  <gj-modal
    :visible.sync="modalVisible"
    size="table"
    :footer="false"
    :content-style="{ height: '100%' }"
    :destroyOnClose="true"
  >
    <template #header>
      <span>操作日志</span>
    </template>
    <template #content>
      <app-base-main no-padding :table-shadow="false">
        <template #filter-group>
          <app-filter-group :query="false" :reset="false">
            <gj-radio-group v-model="opType" :options="OpTypeEnum.options" @input="$gjNoticeQuery">
            </gj-radio-group>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
            :index="false"
            :data="tableData"
            :columns="columns"
            :loading="loading"
            :pagination="pagination"
            :adapt-height="false"
            :height="333"
            @page-change="$gjNoticeQuery"
          >
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, queryMixin } from "../../../../../minxins";
import { OpTypeEnum } from "../common/enum";
import { getLogList } from "../../../../../api/system";
import { isMeaningful } from "../../../../../utils/common";

export default {
  name: "app-tag-op-log-modal",
  mixins: [modalMixIn, queryMixin],
  props: {
    url: {
      url: String,
    },
  },
  data() {
    return {
      tableData: [],
      columns: [
        {
          id: "createTime",
          header: "操作时间",
          field: "createTime",
          minWidth: "120px",
          default: true,
        },
        {
          id: "userName",
          header: "操作用户",
          field: "userName",
          minWidth: "100px",
          default: true,
        },
        {
          id: "op",
          header: "操作分类",
          field: "op",
          minWidth: "120px",
          default: true,
        },
        {
          id: "content",
          header: "操作内容",
          field: "content",
          minWidth: "300px",
          default: true,
        },
      ],
      OpTypeEnum: OpTypeEnum,
      opType: null,
    };
  },
  methods: {
    $gjQuery() {
      this.loading = true;
      const params = {
        model: {
          type: this.opType,
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      getLogList(params)
        .then((data) => {
          if (isMeaningful(data)) {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          } else {
            this.tableData = [];
          }
        })
        .complete(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>

